import { Card, Icon, TextField, Button, Chip } from "@mui/material"
import InsertLinkIcon from "@mui/icons-material/InsertLink"
import FilterListIcon from "@mui/icons-material/FilterList"
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DataTable from "components/DataTable"
import { useState, useEffect } from "react"
import { titleTypography } from "shared/styles/style"
import { useLazyGetDashboardClassQuery } from "shared/redux/endpoints/sso"
import { createMockClassSituationResponse } from "./classSituationMockData"
import ReactPaginate from "react-paginate"
import Filters from "components/FilterClassSituation/FilterClassSituation"
import ColumnVisibility from "components/ColumnVisibilityClassSituation/ColumnVisibilityClassSituation"
import { Loading } from "shared/components/ui/Loading"
const toKebabCase = (str) => {
  return str ? str.toLowerCase().replace(/\s+/g, "-") : ""
}

function ClassSituation() {
  const [isLoading, setIsLoading] = useState(true)
  // Danh sách 19 cột mặc định (không thay đổi)
  const defaultColumns = [
    { Header: "No", accessor: "no", width: "44px" },
    { Header: "Group KOC", accessor: "groupKOC", width: "160px" },
    { Header: "KOC", accessor: "koc", width: "180px" },
    { Header: "Level", accessor: "level", width: "180px" },
    { Header: "Class Name", accessor: "className", width: "260px" },
    { Header: "Hub Class Link", accessor: "hubClassLink", width: "120px" },
    { Header: "Schedule", accessor: "schedule", width: "210px" },
    { Header: "Class Status", accessor: "classStatus" },
    { Header: "Teacher", accessor: "teacher" },
    { Header: "CXO", accessor: "CXO" },
    { Header: "Hours Week", accessor: "hoursWeek" },
    { Header: "Start Date", accessor: "startDate" },
    { Header: "End Of Module A", accessor: "endOfModuleA" },
    { Header: "End Of Module B", accessor: "endOfModuleB" },
    { Header: "End Of Module C", accessor: "endOfModuleC" },
    { Header: "Hours Learned", accessor: "hoursLearned" },
    { Header: "Total", accessor: "total" },
    { Header: "Waiting", accessor: "waiting" },
    { Header: "Level Name", accessor: "level_name" },
    { Header: "Total Student", accessor: "totalStudent" },
  ]

  const [state, setState] = useState({
    page: 0,
    size: 10,
    filters: {
      search: "",
      groupKOC: "",
      level: "",
      classStatus: "",
      scheduleDay: "",
      teacher: "",
      CXO: "",
    },
  })

  const [pagination, setPagination] = useState({
    totalPage: 0,
    currentPage: 0,
  })

  const [trigger] = createMockClassSituationResponse()

  const [filterAnchorEl, setFilterAnchorEl] = useState(null)
  const [columnAnchorEl, setColumnAnchorEl] = useState(null)

  const [dataTable, setDataTable] = useState({
    columns: defaultColumns,
    rows: [],
  })

  const [visibleColumns, setVisibleColumns] = useState(
    defaultColumns.map((col) => col.accessor)
  )

  const filteredColumns = defaultColumns.filter((col) =>
    visibleColumns.includes(col.accessor)
  )

  const handlerDataTable = (data) => {
    setDataTable({
      columns: filteredColumns,
      rows: data.map((item) => ({
        ...item,
        hubClassLink: (
          <a
            className={`class-situation-table-hub-class-link`}
            href={item.hubClassLink}
            target="_blank"
            rel="noreferrer"
          >
            <InsertLinkIcon /> {item.hubClassLink}
          </a>
        ),
        classStatus: (
          <MDTypography>
            <Chip
              label={item.classStatus}
              className={`class-situation-table-status ${toKebabCase(
                item.classStatus
              )}`}
            />
          </MDTypography>
        ),
      })),
    })
  }

  const handlderAPIList = (params) => {
    trigger(params).then((res) => {
      handlerDataTable(res?.data?.data)
      setPagination({
        ...pagination,
        totalPage: res?.data?.totalPage,
        currentPage: res?.data?.currentPage,
      })
      setIsLoading(false)
    })
  }

  const handleChangePage = (page) => {
    handlderAPIList({
      ...state,
      page: page,
    })
  }

  const handleSearchChange = (e) => {
    const newSearch = e.target.value
    const updatedFilters = { ...state.filters, search: newSearch }
    setState({ ...state, filters: updatedFilters, page: 0 })
    handlderAPIList({ ...state, filters: updatedFilters, page: 0 })
  }

  const handleFilterSubmit = (newFilters) => {
    const updatedFilters = { ...state.filters, ...newFilters }
    setState({ ...state, filters: updatedFilters, page: 0 })
    handlderAPIList({ ...state, filters: updatedFilters, page: 0 })
  }

  const handleColumnSubmit = (newVisibleColumns) => {
    setVisibleColumns(newVisibleColumns)
    setDataTable({
      ...dataTable,
      columns: defaultColumns.filter((col) =>
        newVisibleColumns.includes(col.accessor)
      ),
    })
  }

  useEffect(() => {
    setTimeout(() => {
      handlderAPIList(state)
    }, 1000)
  }, [visibleColumns])

  return (
    <MDBox mb={3} className={`class-situation`}>
      {isLoading ? (
        <Loading style={{ height: 200, margin: "10% auto" }} />
      ) : (
        <Card>
          <MDBox p={3} lineHeight={1}>
            <MDTypography
              sx={({ breakpoints }) => ({ ...titleTypography(breakpoints) })}
            >
              Class Situation
            </MDTypography>
          </MDBox>

          {/* Thêm ô tìm kiếm và nút Filter */}
          <MDBox
            px={3}
            pb={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <TextField
              label="Search by class name"
              value={state.search}
              onChange={handleSearchChange}
              variant="outlined"
              size="small"
              sx={{ width: "300px" }}
            />
            <MDBox display="flex" gap={2}>
              <Button
                className={`btn-top-table`}
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={(event) => setFilterAnchorEl(event.currentTarget)}
              >
                Filter
              </Button>
              <Button
                className={`btn-top-table`}
                variant="outlined"
                //startIcon={<TableRowsOutlinedIcon />}
                onClick={(event) => setColumnAnchorEl(event.currentTarget)}
              >
                <TableRowsOutlinedIcon />
              </Button>
            </MDBox>
          </MDBox>

          <Filters
            initialFilters={state.filters}
            onSubmit={handleFilterSubmit}
            anchorEl={filterAnchorEl}
            setAnchorEl={setFilterAnchorEl}
            // classes={classes}
            className={`class-situation-filter`}
          />

          <ColumnVisibility
            initialColumns={defaultColumns}
            visibleColumns={visibleColumns}
            setVisibleColumns={setVisibleColumns}
            onSubmit={handleColumnSubmit}
            anchorEl={columnAnchorEl}
            setAnchorEl={setColumnAnchorEl}
            // classes={classes}
            className={`class-situation-column`}
          />

          <MDBox className="teacher-management__table-wrapper">
            <DataTable
              table={dataTable}
              entriesPerPage={{
                isShown: true,
                defaultValue: state.size,
                entries: [5, 10, 25],
                pagination: true,
              }}
            />
            <MDBox className="table-footer">
              <MDBox className="table-footer-showing">
                Showing {dataTable?.rows?.length} of {dataTable?.rows?.length}{" "}
                entries
              </MDBox>
              {pagination.totalPage >= 0 && (
                <ReactPaginate
                  className="pagination"
                  nextLabel={<Icon>chevron_right</Icon>}
                  previousLabel={<Icon>chevron_left</Icon>}
                  forcePage={Number(state.page)}
                  onPageChange={(event) => {
                    handleChangePage(event.selected)
                  }}
                  pageCount={pagination.totalPage}
                />
              )}
            </MDBox>
          </MDBox>
        </Card>
      )}
    </MDBox>
  )
}

export default ClassSituation
